import { useStaticQuery } from "gatsby";
var useCmsEdition = function useCmsEdition() {
    var data = useStaticQuery("4078341254");
    return data;
};
export default useCmsEdition;
